var $ = global.jQuery = global.$;

var _Base = require('./_Base');

/**
 * Print widget
 * @class
 * @extends _Base
 */
var Print = _Base.extend(
  /** @lends Print.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$el.on('click', function(event) {
      event.preventDefault();
      if (typeof window.print === 'function') {
        window.print();
      }
    });
  }
});

module.exports = Print;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Print.js
// module id = 42
// module chunks = 0 1